import { Injectable } from '@angular/core';

import { jwtDecode } from 'jwt-decode';

import { SafeAny } from '../../types/safe-any';

interface JwtPayload {
  exp: number; // Expiration time (Unix timestamp)
  iat: number; // Issued at time
  [key: string]: SafeAny;
}

@Injectable({
  providedIn: 'root',
})
export class TokenValidationService {
  /**
   * Validates if a JWT token is valid and not expired
   * @param token - The JWT token to validate
   * @returns boolean - true if token is valid and not expired
   */
  isTokenValid(token: string | null): boolean {
    if (!token) {
      return false;
    }

    try {
      const decoded = jwtDecode<JwtPayload>(token);

      // Check if token has expiration
      if (!decoded.exp) {
        return false;
      }

      // Check if token is expired (exp is in seconds, Date.now() is in milliseconds)
      const currentTime = Math.floor(Date.now() / 1000);
      return decoded.exp > currentTime;
    } catch (error) {
      // Token is malformed or invalid
      console.error('Invalid token format:', error);
      return false;
    }
  }
}
